import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

interface CartStickyFooterProps {
  total: number;
  currency: string;
  onCheckout: () => void;
  disabled?: boolean;
  isSubmitting?: boolean;
  itemCount: number;
}

export const CartStickyFooter: React.FC<CartStickyFooterProps> = ({
  total,
  currency,
  onCheckout,
  disabled,
  isSubmitting,
  itemCount,
}) => {
  const { t } = useTranslation();

  if (itemCount === 0) return null;

  return (
    <motion.div 
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-50 md:static md:shadow-none md:border-0 md:p-0 md:bg-transparent"
    >
      <div className="max-w-md mx-auto md:max-w-none">
        <Button
          onClick={onCheckout}
          disabled={disabled || isSubmitting}
          className="w-full h-14 text-lg font-bold rounded-xl shadow-lg shadow-primary/20 flex justify-between items-center px-6"
          size="lg"
        >
          <span className="bg-white/20 px-3 py-1 rounded-lg text-sm font-bold min-w-[2rem] text-center">
            {itemCount}
          </span>
          
          <span>
            {isSubmitting ? t('common.sending', 'جاري الإرسال...') : t('cart.send_order', 'إرسال الطلب')}
          </span>
          
          <span>
            {total.toFixed(2)} {currency}
          </span>
        </Button>
      </div>
    </motion.div>
  );
};
